//
// bw-paths.js: site path helpers
//

import {country_code} from './site-lang';

let _path_base;

function path_base() {
  if (_path_base === undefined) {
    const cc = country_code();
    _path_base = cc == 'en' ? '/' : `/${cc}/`;
  }
  return _path_base;
}

function path_theme(file) {
  let path = 'wp-content/themes/brandwatch/';
  if (typeof file !== 'undefined') {
    path += file;
  }
  return path_base() + path;
}

function path_blog() {
  return path_base() + 'blog/';
}

function path_spritesheet() {
  return path_theme('/build/sprite-map-2020-pitchbox.svg');
}

function editor_thumb(thumb) {
  return path_theme(`src/core/blocks/thumbnails/${thumb}`);
}

export {
  path_base,
  path_theme,
  path_blog,
  path_spritesheet,
  editor_thumb,
};

